export type WorkspaceFlowEntry = {
  flow_id: string;
  name: string;
  decisions_30d: number;
};

export type WorkspaceInsightsAgentContext = {
  environment: string;
  flows: WorkspaceFlowEntry[];
  flow_count: number;
};

export const MAX_FLOWS = 50;

type WorkspaceInsightsAgentContextInputs = {
  environment: string;
  flowVolumes: { flowId: string; decisions30d: number }[];
  flowIdToName: Record<string, string>;
  flowCount: number;
};

export const buildWorkspaceInsightsAgentContext = ({
  environment,
  flowVolumes,
  flowIdToName,
  flowCount,
}: WorkspaceInsightsAgentContextInputs): WorkspaceInsightsAgentContext => ({
  environment,
  flows: flowVolumes
    .filter(({ flowId }) => flowIdToName[flowId])
    .slice(0, MAX_FLOWS)
    .map(({ flowId, decisions30d }) => ({
      flow_id: flowId,
      name: flowIdToName[flowId],
      decisions_30d: decisions30d,
    })),
  flow_count: flowCount,
});
